import { render, staticRenderFns } from "./AccountInvoicePolicy.vue?vue&type=template&id=e83b97be&"
import script from "./AccountInvoicePolicy.vue?vue&type=script&lang=js&"
export * from "./AccountInvoicePolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports